import {
  ClubProgrammeStatus,
  ClubProgrammeSelectionMode,
  ClubProgrammePreBookingAccess
} from 'Src/types/clubProgramme';

export const CLUB_PROGRAMME_TABS = {
  SUMMARY: 'Summary',
  CLUBS: 'Clubs',
  FIELDS: 'Fields',
  BOOKINGS: 'Bookings'
};

export const CLUB_PROGRAMME_TABS_ARRAY = [
  CLUB_PROGRAMME_TABS.SUMMARY,
  CLUB_PROGRAMME_TABS.CLUBS,
  CLUB_PROGRAMME_TABS.FIELDS,
  CLUB_PROGRAMME_TABS.BOOKINGS
];

export const CLUB_PROGRAMME_CLUBS_TABS = {
  SUMMARY: 'Summary',
  FIELDS: 'Fields',
  INVITES_ONLY: 'By invitations only'
};

export const CLUB_PROGRAMME_CLUBS_TABS_ARRAY = [
  CLUB_PROGRAMME_CLUBS_TABS.SUMMARY,
  CLUB_PROGRAMME_CLUBS_TABS.FIELDS,
  CLUB_PROGRAMME_CLUBS_TABS.INVITES_ONLY
];

export const CLUB_PROGRAMME_SORT_UI_TO_SERVER: Record<string, string> = {
  bookingOpensAt: 'booking.opensAt',
  bookingClosesAt: 'booking.closesAt',
  preBookingAccess: 'booking.preBookingAccess',
  selectionMode: 'selectionRules.mode'
};

export const CLUB_PROGRAMME_WHERE_UI_TO_SERVER: Record<string, string> = {
  bookingOpensAt: 'booking.opensAt',
  bookingClosesAt: 'booking.closesAt',
  preBookingAccess: 'booking.preBookingAccess',
  selectionMode: 'selectionRules.mode'
};

export const CLUB_PROGRAMME_STATUS_OPTIONS: ClubProgrammeStatus[] = ['DRAFT', 'ACTIVE', 'COMPLETED', 'ARCHIVED'];
export const CLUB_PROGRAMME_SELECTION_MODE_OPTIONS: ClubProgrammeSelectionMode[] = ['SINGLE', 'PRIORITY'];
export const CLUB_PROGRAMME_PREBOOKING_ACCESS_OPTIONS: ClubProgrammePreBookingAccess[] = ['HIDE', 'VIEW', 'DRAFT'];
